export const en = {
    degree: '°C',
    from: 'from',
    to: 'to',
    'warning-one-more-item': 'Select at least one value'
};
